import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom"; // ← ESTA LÍNEA FALTABA
import API from "../api/api";
import { UserContext } from "../context/UserContext";
import { GrupoContext } from "../context/GrupoContext";
import { AlertContext } from "../context/AlertContext";
import Navbar from "./Navbar";
import Hero from "./Hero";
import PartidosFaseGrupos from "./PartidosFaseGrupos";
import DragDrop from "./DragDrop";
import ModalInvitar from "./ModalInvitar";
import ModalSolicitudes from "./ModalSolicitudes";
import "../css/Home.css";
import Eliminatorias from "./Eliminatorias";
import DieciseisAvos from "./DieciseisAvos";
import Octavos from "./Octavos";
import Cuartos from "./Cuartos";
import Semis from "./Semis";
import Final from "./Final";
import Campeones from "./Campeones";
import { useMemo } from "react";
import ComprarPuntos from "./ComprarPuntos";

import Cards from "./components/Cards";
import { Fase } from "../shared/multiplicadores";



interface Seleccion {
  id: number;
  nombre: string;
  bandera: string;
}

interface IPartido {
  id: number;
  grupo: string;
  id_local: number;
  local_nombre: string;
  local_bandera: string;
  id_visitante: number;
  visitante_nombre: string;
  visitante_bandera: string;
  fecha: string;
  goles_local: number | null;
  goles_visitante: number | null;
  estado: "pendiente" | "jugado";
  liquidado?: boolean; // ← AÑADILO AQUÍ
  partido: PartidoCard;
}


interface IPrediccion {
  id_partido: number;
  prediccion_local: number;
  prediccion_visitante: number;
  apuesta: number;
  puntos_ganados?: number | null; // ← NUEVO
  acertado?: boolean | null;       // ← NUEVO
}

interface PartidoCard {
  local_nombre: string;
  visitante_nombre: string;
  local_bandera: string;
  visitante_bandera: string;
  local_grupo?: string;
  visitante_grupo?: string;
  fecha?: string;
}




// Home
const Home = () => {
  const userCtx = useContext(UserContext);
  const user = userCtx?.user ?? null;
 const [rankingGlobal, setRankingGlobal] = useState<{
  top9: { id: number; nombre: string; puntos: number }[];
  yo: { id: number; nombre: string; puntos: number; posicion: number } | null;
}>({
  top9: [],
  yo: null,
});


  const grupoCtx = useContext(GrupoContext);
  const alertCtx = useContext(AlertContext);
  const showAlert = alertCtx?.showAlert ?? (() => {});
  const { refreshUser } = userCtx ?? {};
  


  /**------------protegemos rutas */
const navigate = useNavigate();

// Función para proteger acciones
const requireLogin = (action: () => void, message = "Iniciá sesión para participar ⚽") => {
  if (!user) {
    showAlert(message, "info"); // ← "info" en lugar de "warning"
    navigate("/login");
    return;
  }
  action();
}
 
const handleInvitar = () => setModalTipo("invitar");
const handleSolicitudes = () => setModalTipo("solicitudes");


  /**------------protegemos rutas */

  // Estado
  const [partidos, setPartidos] = useState<IPartido[]>([]);
  const [predicciones, setPredicciones] = useState<IPrediccion[]>([]);
  const [partidoSeleccionado, setPartidoSeleccionado] = useState<IPartido | null>(null);
  const [guardando, setGuardando] = useState(false);
  const [modalTipo, setModalTipo] = useState<"invitar" | "solicitudes" | null>(null);
  const [toastMsg, setToastMsg] = useState("");
  const [promos, setPromos] = useState([]);
  const rankingAmigos = grupoCtx?.rankingAmigos ?? null;
  const [estadoTorneo, setEstadoTorneo] = useState<Fase>("grupos");
  interface ResultadoGrupo {
  grupo: string;
  predicho_primero: number;
  predicho_segundo: number;
  puntos_ganados: number;
  acertado: number;
}

const [resultadosGrupos, setResultadosGrupos] = useState<
  Record<string, ResultadoGrupo>
>({});


const guardarOrdenGrupo = async (grupo: string, orden: Seleccion[]) => {
  if (!user) return;

  await API.post("/admin-drag/guardar-orden", {
    id_usuario: user.id,
    grupo,
    primero: orden[0].id,
    segundo: orden[1].id
  });
};



  const fetchRanking = async () => {
  try {
    let res;
    if (user?.id) {
      res = await API.get(`/grupos/ranking/global/${user.id}`);
    } else {
      res = await API.get(`/grupos/ranking`);
    }
    setRankingGlobal(res.data);
  } catch (error) {
    console.error("Error ranking global:", error);
  }
};

useEffect(() => {
  fetchRanking();
}, [user?.id]);


  // CARGA 1: Partidos (con mejor manejo de errores)
useEffect(() => {
  const fetchPartidos = async () => {
    try {
      const res = await API.get("/partidos");
      console.log("Respuesta API /partidos:", res.data); // ← debug clave

      const data = res.data;

      if (Array.isArray(data)) {
        setPartidos(data);
      } else {
        console.warn("API /partidos no devolvió array:", data);
        setPartidos([]); // fallback seguro
      }
    } catch (error: any) {
      console.error("Error al obtener partidos:", error.message || error);
      if (error.response?.status === 404) {
        console.warn("Ruta /api/partidos no encontrada en el backend");
      }
      setPartidos([]); // fallback
    }
  };

  fetchPartidos();
}, []);



  // CARGA 2: Predicciones
  useEffect(() => {
    if (!user) return;
    API.get(`/predicciones?id_usuario=${user.id}`)
      .then((res) => setPredicciones(res.data || []))
      .catch((e) => console.error("Error al cargar predicciones:", e));
  }, [user?.id]);

  useEffect(() => {
    if (!grupoCtx?.miGrupo) return;
    grupoCtx.cargarRankingAmigos();
  }, [grupoCtx?.miGrupo]);

  useEffect(() => {
  API.get("/torneo/fase")
    .then(res => setEstadoTorneo(res.data.fase as Fase))
    .catch(() => setEstadoTorneo("grupos"));
}, []);

const FECHA_LIMITE = new Date("2026-06-10T23:59:59");
const ahora = new Date();
const prediccionesBloqueadas = ahora > FECHA_LIMITE;

const dragDropBloqueado =
  estadoTorneo !== "grupos" ||
  prediccionesBloqueadas;


useEffect(() => {
  if (!user) return; 

  const fetchResultados = async () => {
    try {
      const res = await API.get(`/admin-drag/grupos/${user.id}`);
      
      const formateado: any = {};
      res.data.forEach((r: any) => {
        formateado[r.grupo] = r;
      });

      setResultadosGrupos(formateado);
      
      await refreshUser?.();

    } catch (err) {
      console.error("Error cargando resultados grupos", err);
    }
  };

  fetchResultados();
}, [estadoTorneo, user?.id]);

useEffect(() => {
  console.log("FASE DESDE BACK:", estadoTorneo);
}, [estadoTorneo]);

useEffect(() => {
  if (!user) return;
  fetchResultadosGrupos();
}, [user?.id]);

useEffect(() => {
  API.get("/pagos/promos")
  .then(res => setPromos(res.data))
}, []);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  if (params.get("status") === "approved") {
    refreshUser?.();
    window.history.replaceState({}, document.title, "/");
  }
}, []);

  
const FASE_ACTUAL: Fase = estadoTorneo;

  
const guardarPrediccion = async (
  gLocal: number,
  gVisitante: number,
  apuesta: number
) => {
  if (!user || !partidoSeleccionado) return;

  setGuardando(true);
  try {
   await API.post("/predicciones", {
        id_usuario: user.id,
        id_partido: partidoSeleccionado.id,
        prediccion_local: gLocal,
        prediccion_visitante: gVisitante,
        apuesta,
        fase: FASE_ACTUAL,
      });


    // 🔁 ACTUALIZAMOS EL USUARIO (puntos)
    await refreshUser?.(); // 👈 ACÁ ES CLAVE

    setPredicciones((prev) => [
      ...prev.filter((p) => p.id_partido !== partidoSeleccionado.id),
      {
        id_partido: partidoSeleccionado.id,
        prediccion_local: gLocal,
        prediccion_visitante: gVisitante,
        apuesta,
      },
    ]);

    setToastMsg("Predicción guardada ✔");
    setTimeout(() => setToastMsg(""), 2000);
    setPartidoSeleccionado(null);
  } catch {
    showAlert("Error al guardar predicción", "error");
  } finally {
    setGuardando(false);
  }
};




const obtenerPrediccion = (idPartido: number) =>
  predicciones.find((p) => p.id_partido === idPartido);

  // Agrupar partidos
 const grupos = useMemo(() => {
  if (!Array.isArray(partidos)) return {};

  return partidos.reduce((acc: Record<string, IPartido[]>, p) => {
    if (!acc[p.grupo]) acc[p.grupo] = [];
    acc[p.grupo].push(p);
    return acc;
  }, {});
}, [partidos]);


const equiposPorGrupo = useMemo(() => {
  return Object.fromEntries(
    Object.keys(grupos).map((grupoKey) => {

      const equiposBase = Array.from(
        new Map(
          grupos[grupoKey].flatMap((p: IPartido) => [
            [p.id_local, { id: p.id_local, nombre: p.local_nombre, bandera: p.local_bandera }],
            [p.id_visitante, { id: p.id_visitante, nombre: p.visitante_nombre, bandera: p.visitante_bandera }],
          ])
        ).values()
      );

      const pred = resultadosGrupos[grupoKey];

      if (!pred) return [grupoKey, equiposBase];

     const primero = equiposBase.find(e => e.id === pred.predicho_primero);
    const segundo = equiposBase.find(e => e.id === pred.predicho_segundo);

    if (!primero || !segundo) {
      return [grupoKey, equiposBase];
    }

    const resto = equiposBase.filter(
      e => e.id !== pred.predicho_primero && e.id !== pred.predicho_segundo
    );

    return [grupoKey, [primero, segundo, ...resto] as Seleccion[]];

        })
      );
}, [grupos, resultadosGrupos]);


  
const getCardState = (
  p: IPartido,
  pred: IPrediccion | undefined,
  user?: any
) => {

  const bloqueado = !puedePredecir(p, pred);

  // 🔒 FASE CERRADA + SIN PREDICCIÓN
  if (!pred && bloqueado) {
    return "no-prediccion";
  }

  // 🟢 Nunca interactuó
  if (user && !pred) {
    return "inicial";
  }

  // ❌ No existe predicción
  if (!pred) return "no-prediccion";

  // 🔥 SI HAY PREDICCIÓN Y NO SE JUGÓ → SIEMPRE ESPERANDO
  if (p.goles_local === null || p.goles_visitante === null) {
    return "esperando";
  }

  // 👑 Exacto
  const exacto =
    pred.prediccion_local === p.goles_local &&
    pred.prediccion_visitante === p.goles_visitante;

  if (exacto) return "legendaria";

  // 🟡 Parcial
  const parcial =
    (pred.prediccion_local > pred.prediccion_visitante && p.goles_local > p.goles_visitante) ||
    (pred.prediccion_local < pred.prediccion_visitante && p.goles_local < p.goles_visitante) ||
    (pred.prediccion_local === pred.prediccion_visitante &&
     p.goles_local === p.goles_visitante);

  if (parcial) return "acierto-parcial";

  return "fallo";
};



const puedePredecir = (p: IPartido, pred: IPrediccion | undefined) => {

  if (prediccionesBloqueadas) return false;
  
  if (p.goles_local !== null || p.goles_visitante !== null) return false; 
  return true;
};

// Contador regresivo
const [tiempoRestante, setTiempoRestante] = useState("");

const calcularTiempoRestante = () => {
  const diff = FECHA_LIMITE.getTime() - new Date().getTime();
  if (diff <= 0) {
    setTiempoRestante("¡Predicciones cerradas!");
    return;
  }

  const dias = Math.floor(diff / (1000 * 60 * 60 * 24));
  const horas = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const segundos = Math.floor((diff % (1000 * 60)) / 1000);

  setTiempoRestante(`${dias}d ${horas}h ${minutos}m ${segundos}s restantes para predecir`);
};

useEffect(() => {
  if (prediccionesBloqueadas) {
    setTiempoRestante("¡Predicciones cerradas!");
    return;
  }

  calcularTiempoRestante(); // ← Calcula inmediatamente

  const interval = setInterval(calcularTiempoRestante, 1000); // ← Cada segundo para que sea más bonito

  return () => clearInterval(interval);
}, []);

const fetchResultadosGrupos = async () => {
  if (!user) return;

  const res = await API.get(`/admin-drag/grupos/${user.id}`);

  const formateado: any = {};
  res.data.forEach((r: any) => {
    formateado[r.grupo] = r;
  });

  setResultadosGrupos(formateado);
};


const confirmarGrupo = async (grupo: string) => {
  if (!user) return;

  await API.post("/admin-drag/confirmar-grupo", {
    id_usuario: user.id,
    grupo
  });

  showAlert("Predicción confirmada ✅", "success");

  await fetchResultadosGrupos(); // 👈 clave
};



const getGrupoEstado = (grupoKey: string) => {
  const resultado = resultadosGrupos[grupoKey];

  if (!resultado) return "inicial";

  // 🟡 Mientras la fase sea "grupos", nunca mostrar fallo
  if (estadoTorneo === "grupos") {
    return "esperando";
  }

  // 🔒 Una vez cerrada la fase
  if (resultado.puntos_ganados === 200) return "perfecto";
  if (resultado.puntos_ganados === 50) return "parcial";
  if (resultado.puntos_ganados === 0) return "fallo";

  return "esperando";
};

const faseEsOPosterior = (fase: Fase) => {
  const orden: Fase[] = [
    "grupos",
    "dieciseisavos",  
    "octavos",
    "cuartos",
    "semifinal",
    "final",
  ];

  return (
    orden.indexOf(estadoTorneo) >=
    orden.indexOf(fase)
  );
};



  return (
    <>
      <Navbar estadoTorneo={estadoTorneo} />
      
        <Hero
          rankingGlobal={rankingGlobal}   
          rankingAmigos={rankingAmigos}
          onInvitar={handleInvitar}
          onSolicitudes={handleSolicitudes}
        />
        <div className="home-container">  
        {modalTipo === "invitar" && <ModalInvitar onClose={() => setModalTipo(null)} />}
        {modalTipo === "solicitudes" && <ModalSolicitudes onClose={() => setModalTipo(null)} />}
        
        {toastMsg && <div className="toast">{toastMsg}</div>}
        
        {partidoSeleccionado && (
          <PartidosFaseGrupos
            partido={partidoSeleccionado}
            fase={estadoTorneo as Fase}
            prediccion={obtenerPrediccion(partidoSeleccionado.id)}
            puntosDisponibles={user?.puntos ?? 0}
            guardando={guardando}
            onClose={() => setPartidoSeleccionado(null)}
            onSave={guardarPrediccion}
          />


        )}

        <section id="grupos">
          <h2 className="fase-grupos-title">Fase de Grupos</h2>

        
        {!prediccionesBloqueadas && (
          <div className="contador-regresivo">
            ⏰ <strong>{tiempoRestante}</strong>
          </div>
        )}
        </section>

        {prediccionesBloqueadas && (
          <div className="predicciones-cerradas">
            🔒 Predicciones cerradas desde el 10 de junio de 2026
          </div>
        )}

        {Object.keys(grupos).map((grupoKey) => {
          const estadoGrupo = getGrupoEstado(grupoKey);
          const partidosGrupo = grupos[grupoKey];
          const yaConfirmado =
          resultadosGrupos[grupoKey]?.acertado !== undefined;
          return (
            <div key={grupoKey} className="grupo-section">
              <h3 className="grupo-title">{grupoKey}</h3>
              
              <div className="grupo-grid">
                {partidosGrupo.map((p: IPartido) => {
                    const pred = obtenerPrediccion(p.id);
                    const state = getCardState(p, pred, user);
                    


                    return (
                      <Cards
                      key={p.id}
                      partido={{
                        ...p,
                        local_nombre: p.local_nombre,
                        visitante_nombre: p.visitante_nombre,
                        local_bandera: p.local_bandera,
                        visitante_bandera: p.visitante_bandera,
                        local_grupo: p.grupo,
                        visitante_grupo: p.grupo,
                      }}
                      pred={pred}
                      
                      state={state}
                      fase={estadoTorneo as Fase}
                      usuarioLogueado={!!user}
                      puedePredecir={puedePredecir(p, pred)}
                      onPredecir={() => requireLogin(() => setPartidoSeleccionado(p))}
                      onEditar={() => requireLogin(() => setPartidoSeleccionado(p))}
                    />


                    );
                  })
                  }

              </div>
              
              <div className="drag-drop-section">
                

               <DragDrop
                  grupo={grupoKey}
                  equipos={equiposPorGrupo[grupoKey]}
                  bloqueado={dragDropBloqueado || yaConfirmado}
                  estado={estadoGrupo}
                  onGuardarOrden={(orden) =>
                    requireLogin(() => guardarOrdenGrupo(grupoKey, orden))
                  }
                />

               {!dragDropBloqueado && !yaConfirmado && (
                  <button
                    className="confirmar-btn"
                    onClick={() =>
                      requireLogin(() => confirmarGrupo(grupoKey))
                    }
                  >
                    Confirmar predicción
                  </button>
                )}

              </div>

            </div>
          );
        })}
      </div>     

{faseEsOPosterior("dieciseisavos") && (
  <section id="dieciseisavos">
    <DieciseisAvos />
  </section>
)}

{faseEsOPosterior("octavos") && (
  <section id="octavos">
    <Octavos />
  </section>
)}

{faseEsOPosterior("cuartos") && (
  <section id="cuartos">
    <Cuartos />
  </section>
)}

{faseEsOPosterior("semifinal") && (
  <section id="semifinal">
    <Semis />
  </section>
)}

{faseEsOPosterior("final") && (
  <section id="final">
    <Final />
  </section>
)}

<section id="campeon" className="campeones-section">
  <h2 className="fase-grupos-title">Podio Final</h2>
  <Campeones />
</section>

{user && (
  <section id="comprar-puntos" className="comprar-puntos-section">
  <ComprarPuntos user={user} />
</section>
)}
    </>
  );
};

export default Home;